export default "__VITE_ASSET__Ccx3dr3f__"